/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
    SourceContactTagToJSONTyped,
} from './SourceContactTag';

/**
 * 
 * @export
 * @interface CreateSourceContactTag201Response
 */
export interface CreateSourceContactTag201Response {
    /**
     * 
     */
    data?: SourceContactTag;
}

/**
 * Check if a given object implements the CreateSourceContactTag201Response interface.
 */
export function instanceOfCreateSourceContactTag201Response(value: object): value is CreateSourceContactTag201Response {
    return true;
}

export function CreateSourceContactTag201ResponseFromJSON(json: any): CreateSourceContactTag201Response {
    return CreateSourceContactTag201ResponseFromJSONTyped(json, false);
}

export function CreateSourceContactTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceContactTag201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SourceContactTagFromJSON(json['data']),
    };
}

export function CreateSourceContactTag201ResponseToJSON(json: any): CreateSourceContactTag201Response {
    return CreateSourceContactTag201ResponseToJSONTyped(json, false);
}

export function CreateSourceContactTag201ResponseToJSONTyped(value?: CreateSourceContactTag201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SourceContactTagToJSON(value['data']),
    };
}

